import BaseSegmentChord from "../../../../../src/entities/BaseSegmentChord";
import { eventBus, EnumEventBus } from "../managers/EventBus";
import { Coord } from "../../../../../src/types/Interface";
import SegmentSwitcherCon from "./SegmentChordSwitcherCon";

export default class SegmentChord extends BaseSegmentChord {
    constructor(cCoord:Coord){
        super(cCoord);
        eventBus.on(EnumEventBus.segmentMode, v => this.handleSegmentVisible(v));
        new SegmentSwitcherCon()
    }
}